import gql from 'graphql-tag';

export const GET_EXAM_CONFIGS = gql`
  query GetExamConfigs {
    examConfigs {
      _id
      description
      endDate
      giftGivingDate
      isEnabled
      name
      pointsToEarn
      resultDate
      startDate
      title
      gifts {
        _id
        isPrivate
        name
        ranking
      }
      classes {
        _id
        name
      }
      disciplinesWithLessons {
        discipline {
          _id
          name
        }
        lessons {
          _id
          name
        }
      }
      series {
        _id
        name
      }
    }
  }
`;
